/** 편제 및 기준 시수 — '기본 편제 예시 불러오기' 학년별 프리셋 (모두 정규, 출판사·와일드카드 비움) */
export type DefaultSubjectPresetRow = {
  name: string;
  alias: string;
  criteriaHours: number;
  termScope: 'split' | 'unified';
};

const G12: DefaultSubjectPresetRow[] = [
  { name: '국어', alias: '국어', criteriaHours: 241, termScope: 'split' },
  { name: '수학', alias: '수학', criteriaHours: 128, termScope: 'split' },
  { name: '바른생활', alias: '바생', criteriaHours: 72, termScope: 'split' },
  { name: '슬기로운생활', alias: '슬생', criteriaHours: 112, termScope: 'split' },
  { name: '즐거운생활', alias: '즐생', criteriaHours: 200, termScope: 'split' },
  { name: '창의적체험활동', alias: '창체', criteriaHours: 119, termScope: 'unified' },
];

const G34: DefaultSubjectPresetRow[] = [
  { name: '국어', alias: '국어', criteriaHours: 204, termScope: 'split' },
  { name: '사회', alias: '사회', criteriaHours: 102, termScope: 'split' },
  { name: '도덕', alias: '도덕', criteriaHours: 34, termScope: 'unified' },
  { name: '수학', alias: '수학', criteriaHours: 136, termScope: 'split' },
  { name: '과학', alias: '과학', criteriaHours: 102, termScope: 'split' },
  { name: '체육', alias: '체육', criteriaHours: 102, termScope: 'unified' },
  { name: '음악', alias: '음악', criteriaHours: 68, termScope: 'unified' },
  { name: '미술', alias: '미술', criteriaHours: 68, termScope: 'unified' },
  { name: '영어', alias: '영어', criteriaHours: 68, termScope: 'unified' },
  { name: '창의적체험활동', alias: '창체', criteriaHours: 102, termScope: 'unified' },
];

const G56: DefaultSubjectPresetRow[] = [
  { name: '국어', alias: '국어', criteriaHours: 204, termScope: 'split' },
  { name: '사회', alias: '사회', criteriaHours: 102, termScope: 'split' },
  { name: '도덕', alias: '도덕', criteriaHours: 34, termScope: 'unified' },
  { name: '수학', alias: '수학', criteriaHours: 136, termScope: 'split' },
  { name: '과학', alias: '과학', criteriaHours: 102, termScope: 'split' },
  { name: '실과', alias: '실과', criteriaHours: 68, termScope: 'unified' },
  { name: '체육', alias: '체육', criteriaHours: 102, termScope: 'unified' },
  { name: '음악', alias: '음악', criteriaHours: 68, termScope: 'unified' },
  { name: '미술', alias: '미술', criteriaHours: 68, termScope: 'unified' },
  { name: '영어', alias: '영어', criteriaHours: 102, termScope: 'unified' },
  { name: '창의적체험활동', alias: '창체', criteriaHours: 102, termScope: 'unified' },
];

export const DEFAULT_SUBJECT_PRESETS: Record<1 | 2 | 3 | 4 | 5 | 6, DefaultSubjectPresetRow[]> = {
  1: G12,
  2: G12,
  3: G34,
  4: G34,
  5: G56,
  6: G56,
};
